import { useContext } from 'react';
import ThemeContext from './views/ThemeContext';
export default (() => useContext(ThemeContext));
//# sourceMappingURL=useTheme.js.map